// src/components/layout/navItems.js
import DashboardIcon from '@mui/icons-material/Dashboard';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import InventoryIcon from '@mui/icons-material/Inventory';
import StoreIcon from '@mui/icons-material/Store';
import GroupIcon from '@mui/icons-material/Group';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CategoryIcon from '@mui/icons-material/Category';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CampaignIcon from '@mui/icons-material/Campaign'; // Ícono para Promociones
import StyleIcon from '@mui/icons-material/Style';
import BusinessIcon from '@mui/icons-material/Business';
import LoyaltyIcon from '@mui/icons-material/Loyalty'; 
export const menuItems = [
    // --- SECCIÓN OPERATIVA ---
    {
        text: 'Dashboard',
        icon: <DashboardIcon />,
        path: '/dashboard',
        roles: ['Gerente', 'Administrador', 'Supervisor de cuenta']
    },
    {
        text: 'Punto de Venta',
        icon: <PointOfSaleIcon />,
        path: '/pos',
        roles: ['Cajero', 'Gerente', 'Administrador']
    },
    
    // --- SECCIÓN LOGÍSTICA ---
    {
        text: 'Logística',
        isSubheader: true,
        roles: ['Cajero', 'Gerente', 'Administrador', 'Supervisor de cuenta']
    },
    {
        text: 'Inventario',
        icon: <InventoryIcon />,
        path: '/inventory',
        roles: ['Gerente', 'Administrador']
    },
    {
        text: 'Compras',
        icon: <ShoppingCartIcon />,
        path: '/purchases',
        roles: ['Gerente', 'Administrador']
    },
    {
        text: 'Transferencias',
        icon: <SwapHorizIcon />,
        path: '/transfers',
        roles: ['Cajero', 'Gerente', 'Administrador']
    },
    {
        text: 'Mermas',
        icon: <ReportProblemIcon />,
        path: '/wastage',
        roles: ['Gerente', 'Administrador']
    },
    
    // --- SECCIÓN DE GESTIÓN ---
    {
        text: 'Administración',
        isSubheader: true,
        roles: ['Administrador', 'Gerente', 'Supervisor de cuenta'] // Añadido Gerente para que vea Productos y Clientes
    },
    {
        text: 'Tiendas',
        icon: <StoreIcon />,
        path: '/admin/stores',
        roles: ['Administrador', 'Supervisor de cuenta']
    },
    {
        text: 'Usuarios',
        icon: <GroupIcon />,
        path: '/admin/users',
        roles: ['Administrador', 'Supervisor de cuenta']
    },
    {
        text: 'Productos',
        icon: <CategoryIcon />,
        path: '/admin/products',
        roles: ['Administrador', 'Gerente']
    },
    {
    text: 'Categorías',
    icon: <StyleIcon />, // Necesitarás importar este ícono de @mui/icons-material
    path: '/admin/categories',
    roles: ['Administrador', 'Gerente']
    },

    {
    text: 'Marcas',
    icon: <LoyaltyIcon />,
    path: '/admin/brands',
    roles: ['Administrador', 'Gerente']
    },
    {
        text: 'Clientes',
        icon: <PeopleAltIcon />,
        path: '/admin/customers',
        roles: ['Gerente', 'Administrador']
    },
    {
    text: 'Proveedores',
    icon: <BusinessIcon />,
    path: '/admin/suppliers',
    roles: ['Administrador', 'Gerente']
    },
    {
    text: 'Gastos',
    icon: <BusinessIcon />,
    path: '/admin/expenses',
    roles: ['Administrador', 'Gerente']
    },
    {
        text: 'Promociones',
        icon: <CampaignIcon />, // <-- 1. AÑADIDO ÍCONO
        path: '/admin/promotions', // <-- 2. RUTA CORREGIDA
        roles: ['Gerente', 'Administrador', 'Supervisor de cuenta'] // <-- 3. ROLES AJUSTADOS
        // No es un subheader
    },

    // --- SECCIÓN DE REPORTES ---
    {
        text: 'Informes',
        isSubheader: true,
        roles: ['Gerente', 'Administrador', 'Supervisor de cuenta']
    },
    {
        text: 'Reportes',
        icon: <AssessmentIcon />,
        path: '/reports',
        roles: ['Gerente', 'Administrador', 'Supervisor de cuenta']
    },
];